import { Continent, ContinentDescriptor } from '@app/enums/continent';
import { ChoroplethMapColors } from '../../plots/plotly-colors';

export interface ChoroplethMapData {
  type: 'choropleth';
  locations: string[];
  z: number[];
  locationmode: 'ISO-3';
  text: string[];
  showscale: boolean;
  colorscale: ChoroplethMapColors;
  [key: string]: unknown;
}

export const ChoroplethMapGeoScopesByGeoLocationTabLabels = Object.freeze({
  Global: undefined,
  [ContinentDescriptor[Continent.Europe]]: 'europe',
  [ContinentDescriptor[Continent.Asia]]: 'asia',
  [ContinentDescriptor[Continent.Africa]]: 'africa',
  [ContinentDescriptor[Continent.NorthAmerica]]: 'north america',
  [ContinentDescriptor[Continent.SouthAmerica]]: 'south america',
  [ContinentDescriptor[Continent.Oceania]]: 'oceania',
  [ContinentDescriptor[Continent.Antarctica]]: 'antarctica',
});
